export const qualifiedListTourSteps = [
  {
    element: '.container-fluid',
    popover: {
      title: 'Contatos Qualificados - Visão Geral',
      description: 'Bem-vindo à tela de Contatos Qualificados! Esta tela permite gerenciar e visualizar todos os contatos qualificados do sistema. Você pode filtrar contatos por cliente, feira, status e contato, visualizar informações detalhadas, editar dados e navegar pelos resultados usando a paginação. Vamos explorar cada funcionalidade em detalhes.',
      side: 'top' as const,
      align: 'center' as const
    }
  },
  {
    element: '#tour-filtros',
    popover: {
      title: 'Filtros de Busca',
      description: 'Use os filtros para encontrar contatos específicos. Você pode filtrar por Cliente, Feira, Status e Contato. Os filtros são aplicados automaticamente conforme você digita.',
      side: 'bottom' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-filtro-cliente',
    popover: {
      title: 'Filtro por Cliente',
      description: 'Digite o nome do cliente para filtrar os contatos. A busca é feita automaticamente enquanto você digita.',
      side: 'bottom' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-filtro-status',
    popover: {
      title: 'Filtro por Status',
      description: 'Selecione um status para filtrar os contatos. Você pode digitar para buscar um status específico ou clicar para ver todas as opções disponíveis.',
      side: 'bottom' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-botao-limpar-filtros',
    popover: {
      title: 'Limpar Filtros',
      description: 'Clique neste botão para remover todos os filtros aplicados e visualizar todos os contatos qualificados novamente.',
      side: 'top' as const,
      align: 'end' as const
    }
  },
  {
    element: '#tour-tabela-contatos',
    popover: {
      title: 'Lista de Contatos Qualificados',
      description: 'Aqui você visualiza todos os contatos qualificados. A tabela exibe informações como Cliente, Feira, Status, Próximo Contato e dados de contato (email e telefone).',
      side: 'top' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-coluna-acoes',
    popover: {
      title: 'Ações Disponíveis',
      description: 'Para cada contato, você pode visualizar os detalhes do cliente ou editar as informações do contato qualificado. As ações disponíveis dependem das suas permissões no sistema.',
      side: 'bottom' as const,
      align: 'start' as const
    }
  },
  {
    element: '#tour-paginacao',
    popover: {
      title: 'Paginação',
      description: 'Use a paginação para navegar entre as páginas de resultados. Você também pode ajustar a quantidade de itens exibidos por página usando o filtro "Itens por página".',
      side: 'top' as const,
      align: 'start' as const
    }
  }
];

